import { Typography, Box } from '@cast/design-system';

type Variant = 'success' | 'error';

const getColor = (variant: Variant) => {
  switch (variant) {
    case 'success':
      return 'green.200';
    case 'error':
      return 'red.200';
    default:
      return 'green.200';
  }
};

const getLabel = (variant: Variant) => {
  switch (variant) {
    case 'success':
      return 'Success!';
    case 'error':
      return 'Failed!';
    default:
      return '';
  }
};

export const NotificationMessage = ({
  children,
  variant = 'success',
}: {
  children: React.ReactNode;
  variant?: Variant;
}) => (
  <Box>
    <Typography
      variant="P14B"
      color={getColor(variant)}
      component="span"
      mr={4}
      textTransform="uppercase"
    >
      {getLabel(variant)}
    </Typography>
    {children}
  </Box>
);
